export default "__VITE_ASSET__4c12ef08__"